import { openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-974ac1b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-wrapper" }
const _hoisted_2 = { class: "edit-content-wrapper" }
const _hoisted_3 = { class: "left_content_bg" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "action_btn_bg" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "require-tips" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "left-save-wrapper" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "has_change_tips" }, "*请及时点击上方“完成配置”保存修改", -1))
const _hoisted_13 = { class: "right_content_bg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseInfoView = _resolveComponent("BaseInfoView")!
  const _component_SocialMediaView = _resolveComponent("SocialMediaView")!
  const _component_DigitalRoleView = _resolveComponent("DigitalRoleView")!
  const _component_DigitalChatSetting = _resolveComponent("DigitalChatSetting")!
  const _component_CreatSpaceView = _resolveComponent("CreatSpaceView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock("iframe", {
            id: "iframe",
            ref: "mobileH5Ref",
            onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPreviewLoad && _ctx.onPreviewLoad(...args))),
            src: _ctx.mobileH5Url,
            frameborder: "0",
            width: "100%",
            height: "100%",
            key: _ctx.refreshIframe
          }, null, 40, _hoisted_5))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([
                        item.index === _ctx.tabIndex ? 'left-btn left-btn-active' : 'left-btn left-btn-hover-style',
                        item.uncomplate ? 'require' : '',
                    ]),
                key: item.index,
                onClick: ($event: any) => (_ctx.changeTab(item.index))
              }, [
                _createTextVNode(_toDisplayString(item.text) + " ", 1),
                _withDirectives(_createElementVNode("span", _hoisted_9, "*请填入必选项", 512), [
                  [_vShow, item.uncomplate]
                ])
              ], 10, _hoisted_8))
            }), 128)),
            _createElementVNode("div", {
              class: _normalizeClass([
                        'left-btn',
                        'left-btn-3d',
                        (!_ctx.linkardId || _ctx.linkardId == 'undefined' || !_ctx.isOwnLinakrd) ? 'left-btn-3d-disabled' : '', _ctx.tabIndex === 4 ? 'left-btn-active' : 'left-btn-hover-style',
                    ]),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toSpace && _ctx.toSpace(...args)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.baseInfo.name) + "的数字空间", 1),
              _createElementVNode("img", {
                src: _ctx.tabIndex === 4 ? require('../assets/images/right_selected.png') : require('../assets/images/right.png'),
                alt: ""
              }, null, 8, _hoisted_10)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "save-btn",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveEdit && _ctx.saveEdit(...args)))
            }, " 完成配置 "),
            _createElementVNode("button", {
              class: "back-btn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)))
            }, "返回"),
            _hoisted_12
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_Transition, {
          name: "subcomponents",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_BaseInfoView, {
              baseInfo: _ctx.baseInfo,
              labelList: _ctx.labelList,
              operation: _ctx.currentLinkardInfo.operation,
              onUpdatePreview: _ctx.updateBaseInfoPreviewInfo
            }, null, 8, ["baseInfo", "labelList", "operation", "onUpdatePreview"]), [
              [_vShow, _ctx.tabIndex === 0]
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "subcomponents",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_SocialMediaView, {
              selectSocialLinkTop: _ctx.selectSocialLinkTop,
              selectSocialLinkNormalList: _ctx.selectSocialLinkNormalList,
              mediaCount: _ctx.linkardConfigInfo?.mediaCount,
              onDeleteTopLink: _ctx.deleteTopLink
            }, null, 8, ["selectSocialLinkTop", "selectSocialLinkNormalList", "mediaCount", "onDeleteTopLink"]), [
              [_vShow, _ctx.tabIndex === 1]
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "subcomponents",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_DigitalRoleView, {
              onGetDigitalRoleInfo: _ctx.getDigitalRoleInfo,
              onSoundSettingUpdate: _ctx.soundSettingUpdate,
              tempCharacterId: _ctx.currentLinkardInfo.npc.characterId,
              tempBackground: _ctx.currentLinkardInfo.npc.background,
              tempBackgroundId: _ctx.currentLinkardInfo.npc.backgroundId,
              personality: _ctx.currentLinkardInfo.npc.personality,
              careerList: _ctx.linkardConfigInfo?.careers,
              toneList: _ctx.linkardConfigInfo?.tones,
              charactList: _ctx.linkardConfigInfo?.characters,
              initialCapabilityList: _ctx.linkardConfigInfo?.abilities,
              voices: _ctx.linkardConfigInfo?.voices,
              voiceId: _ctx.currentLinkardInfo.npc.voice?.voiceId ? _ctx.currentLinkardInfo.npc.voice.voiceId : '',
              characterShow: _ctx.currentLinkardInfo.npc.characterShow,
              backgroundShow: _ctx.currentLinkardInfo.npc.backgroundShow,
              onCharacterAndBgShowChange: _ctx.characterAndBgShowChange
            }, null, 8, ["onGetDigitalRoleInfo", "onSoundSettingUpdate", "tempCharacterId", "tempBackground", "tempBackgroundId", "personality", "careerList", "toneList", "charactList", "initialCapabilityList", "voices", "voiceId", "characterShow", "backgroundShow", "onCharacterAndBgShowChange"]), [
              [_vShow, _ctx.tabIndex === 2]
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "subcomponents",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_DigitalChatSetting, {
              ref: "digitalChatSetting",
              npcDetail: _ctx.currentLinkardInfo.npc,
              modelLibraryList: _ctx.linkardConfigInfo?.availableModels,
              linkardId: _ctx.linkardId,
              linkardType: _ctx.currentLinkardInfo.type,
              onLargeModelUpdate: _ctx.largeModelUpdate
            }, null, 8, ["npcDetail", "modelLibraryList", "linkardId", "linkardType", "onLargeModelUpdate"]), [
              [_vShow, _ctx.tabIndex === 3]
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, {
          name: "subcomponents",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_CreatSpaceView, {
              linkardId: _ctx.linkardId,
              linkardType: _ctx.cardType
            }, null, 8, ["linkardId", "linkardType"]), [
              [_vShow, _ctx.tabIndex === 4]
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}